import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useAtomValue } from "jotai";

import useCloudPermissions from "../../../hooks/useCloudPermissions";
import TenantAPI from "../../api/TenantAPI";
import { handleUpdatedRecords } from "../../../utils/RecordUtils";
import {
  callFunctionIfExists,
  getErrorMessage,
} from "../../../utils/GeneralUtils";
import { tenantIDAtom } from "../../../atoms/GlobalAtoms";

const useMergeRecords = () => {
  const { cPermissions } = useCloudPermissions();
  const queryClient = useQueryClient();
  const tenantID = useAtomValue(tenantIDAtom);

  const updatePageUser = useMutation({
    mutationFn: ({
      moduleAPIName,
      payload,
      onSuccess,
    }: {
      moduleAPIName: string;
      payload: any;
      onSuccess?: () => void;
    }) => {
      if (!cPermissions.cloud_merge_records) {
        return Promise.reject(
          "User does not have permission to merge subitems in this cloud."
        );
      }

      return TenantAPI.mergeSubitems(moduleAPIName, payload).then((data) => {
        const parentRecord = data.data.data.record;

        handleUpdatedRecords(
          queryClient,
          moduleAPIName,
          parentRecord,
          tenantID ?? ""
        );

        callFunctionIfExists(onSuccess);
      });
    },
  });

  return {
    mergeSubitems: updatePageUser.mutate,
    mergingSubitems: updatePageUser.isPending,
    mergeSubitemsError: updatePageUser.error
      ? getErrorMessage(updatePageUser.error)
      : null,
  };
};

export default useMergeRecords;
